/*
 * Copyright (C) 2022 to Present Applause App Quality, Inc. All rights reserved.
 */

import { QueryList } from '@angular/core';
import { concat, defer, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * QueryList changes but typed and starting with current value.
 */
export function queryListChanges<T>(queryList: QueryList<T>): Observable<T[]> {
  return concat(
    defer(() => of(queryList.toArray())),
    queryList.changes.pipe(map(() => queryList.toArray()))
  );
}
